import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import * as z from 'zod'

import {TemplateFreeFormSectionSchema} from './templateFreeFormSection'

export const TemplateFreeFormSchema = buildEntrySchemaFor('templateFreeForm', {
  fields: z.lazy(() =>
    z.object({
      sections: z.array(TemplateFreeFormSectionSchema),
    }),
  ),
})

export type TemplateFreeForm = z.infer<typeof TemplateFreeFormSchema>
